import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import PlusIcon from 'icons/Plus.icon';
import { useTranslation } from 'react-i18next';
import AddBossModeAccount from './components/AddBossModeAccount';
import useCallbackRef from 'hooks/useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';

import './AddBossMode.styles.scss';

type AddBossModeProps = {
  className?: string;
  onAddBossMode: () => void;
};

const AddBossMode: React.FC<AddBossModeProps> = (props) => {
  const { className, onAddBossMode } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>(null);

  const classes = classNames('add-boss-mode', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <Button variant="outline" icon={PlusIcon} onClick={modal?.open}>
        {t('addBossMode')}
      </Button>

      <AddBossModeAccount ref={modalRef} onAddBossMode={onAddBossMode} />
    </div>
  );
};

export default AddBossMode;
